import {
  MonthlySummaryAction,
  LOAD_REPORT_DATA,
  LOAD_REPORT_DATA_FAIL,
  LOAD_REPORT_DATA_REQUEST,
  LOAD_REPORT_DATA_SUCCESS,
} from "./actionTypes";
import { AsyncAction } from "../../store";

// Actions
export function getReportData(): MonthlySummaryAction {
  return { type: LOAD_REPORT_DATA_REQUEST };
}

export function loadReportData(user: any, site: any): AsyncAction {
  return {
    types: [LOAD_REPORT_DATA, LOAD_REPORT_DATA_SUCCESS, LOAD_REPORT_DATA_FAIL],
    promise: (client) =>
      client
        .post(`monthlyreport/${site}`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        })
        .then((response: any) => ({
          site,
          data: { ...response },
        })),
  };
}

export function loadSampleData(_user: any, site: any): AsyncAction {
  return {
    types: [LOAD_REPORT_DATA, LOAD_REPORT_DATA_SUCCESS, LOAD_REPORT_DATA_FAIL],
    promise: () =>
      Promise.resolve().then(() => ({
        site,
        data: { ...require("../../../scenes/Reports/Summary/data") },
      })),
  };
}
